import React, { useState } from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import AddBatchFormWrapper from "../Add/AddBatchFormWrapper";
import { isCheckActionsPermission, isCheckModuleActionForNavigationPath } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const BatchListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [isOpenAddBatchDialog, setIsOpenAddBatchDialog] = useState(false);
  const navigate = useNavigate()
  const { userType } = useSelector((state: RootState) => state.auth);
  return (
    <SideNavLayout>
      <div className="flex flex-col">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="Batches"
            searchValue={searchValue}
            hideAddButton={!isCheckActionsPermission({
              moduleName: UserModuleNameTypes.BATCHES,
              actionName: UserModuleActionTypes.ADD,
            })}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                setIsOpenAddBatchDialog(true);
              },
            }}
          />
        </div>

        {/* Table */}
        <div className="flex flex-col flex-1 px-4 overflow-auto">
          <ATMTable
            columns={columns} 
            onRowClick={(row: any) => {
              
              if (userType === "ADMIN") {
                navigate(`/batches/${row?._id}/students`)
              } else {
                isCheckActionsPermission({
                  moduleName: UserModuleNameTypes.BATCHES,
                  actionName: UserModuleActionTypes.VIEW,
                }) && (isCheckModuleActionForNavigationPath(UserModuleNameTypes.BATCHES, `/batches/${row?._id}`,navigate))
              }
            }
            }
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="flex justify-end p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>

      {isOpenAddBatchDialog ? (
        <AddBatchFormWrapper onClose={() => setIsOpenAddBatchDialog(false)} />
      ) : null}
    </SideNavLayout>
  );
};

export default BatchListing;
